import { render } from "./ICheckbox.vue?vue&type=template&id=09665044"
import script from "./ICheckbox.vue?vue&type=script&lang=js"
export * from "./ICheckbox.vue?vue&type=script&lang=js"

import "./ICheckbox.vue?vue&type=style&index=0&id=09665044&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__